module.exports = __webpack_public_path__ + "media/images/sunbasket_july4th/bg-md-7188cd18717fcb4c891344f4ca301326.jpg";